import { FC, useCallback, useState } from 'react';

import GraphQLQueryRow from '../GraphQLQueryRow';
import GraphQLQueryViewer from '../GraphQLQueryViewer';

import { GraphQLQuery } from '../../types';

import styles from './DebuggerWindow.module.css';
import Toolbar from '../Toolbar';

type Props = {
  data: GraphQLQuery[];
  onClose: () => void;
};

const DebuggerWindow: FC<Props> = ({ data, onClose }) => {
  const [selected, setSelected] = useState<number | null>(null);

  const handleClose = useCallback(() => {
    setSelected(null);
  }, []);

  return (
    <div className={styles.root}>
      <Toolbar onClose={onClose} />

      <div className={styles.window}>
        {data.map((query, i) => (
          <GraphQLQueryRow
            key={i}
            selected={i === selected}
            query={query}
            onClick={() => {
              setSelected(i);
            }}
          />
        ))}

        {selected !== null && (
          <GraphQLQueryViewer query={data[selected]} onClose={handleClose} />
        )}
      </div>
    </div>
  );
};

export default DebuggerWindow;
